<template>
  <div class="content">
    <el-tabs v-model="activeName" :stretch="true" style="background-color: #fff">
      <el-tab-pane label="检验" name="first">
        <div style="height: .2rem;width: 100%;background-color: #f5f5f5" v-if="reportjylist.length>0"></div>
        <div style="height: 1.4rem;width: 100%;border-bottom: .2rem #f5f5f5 solid" v-if="reportjylist.length>0" v-for="(item,index) in reportjylist" :key="index" @click="tojyDetails(item)">
          <el-row>
            <el-col :span="6">
              <div style="height: 1.4rem;text-align: center;">
                <img :src="item.状态=='未发布'?'static/img/weifabu.png':'static/img/yifabu.png'" style="width: 1rem;margin-top: .2rem"/>
              </div>
            </el-col>
            <el-col :span="16">
              <div style="height: .7rem;line-height: .9rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.项目名称}}</div>
              <div style="height: .7rem;line-height: .5rem;color: #999999">{{item.申请时间}}</div>
            </el-col>
            <el-col :span="2" style="height: 1.4rem;line-height: 1.4rem;font-size: .4rem;font-weight: 900;color: #999999">
              <i class="el-icon-arrow-right"></i>
            </el-col>
          </el-row>
        </div>
        <div class="noCard" v-if="!reportjylist.length>0">
          <div class="noCard-img">
            <img src="static/img/noCard.png"/>
          </div>
          <div class="noCard-text">暂无检验报告</div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="检查" name="second">
        <div style="height: .2rem;width: 100%;background-color: #f5f5f5" v-if="reportjclist.length>0"></div>
        <div style="height: 1.4rem;width: 100%;border-bottom: .2rem #f5f5f5 solid" v-if="reportjclist.length>0" v-for="(item,index) in reportjclist" :key="index" @click="tojcDetails(item.申请单ID)">
          <el-row>
            <el-col :span="6">
              <div style="height: 1.4rem;text-align: center;">
                <img :src="item.状态=='未发布'?'static/img/weifabu.png':'static/img/yifabu.png'" style="width: 1rem;margin-top: .2rem"/>
              </div>
            </el-col>
            <el-col :span="16">
              <div style="height: .7rem;line-height: .9rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.检查项目}}</div>
              <div style="height: .7rem;line-height: .5rem;color: #999999">{{item.报告日期}}</div>
            </el-col>
            <el-col :span="2" style="height: 1.4rem;line-height: 1.4rem;font-size: .4rem;font-weight: 900;color: #999999;">
              <i class="el-icon-arrow-right"></i>
            </el-col>
          </el-row>
        </div>
        <div class="noCard" v-if="!reportjclist.length>0">
          <div class="noCard-img">
            <img src="static/img/noCard.png"/>
          </div>
          <div class="noCard-text">暂无检查报告</div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {getreportjylist,getreportjclist} from '../../api/index'
    export default {
      data(){
        return{
          activeName: 'first',
          reportjylist:[],
          reportjclist:[],
        }
      },
      created() {
        //修改标题
        document.title = '报告列表'
        this.getReportjylist()
        this.getReportjclist()
      },
      methods:{
        getReportjylist(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          getreportjylist({
            startdate:this.$route.query.startDate,
            enddate:this.$route.query.endDate,
            name:this.$storage.get('patient').clinic_patient_name,
            cardnum:this.$storage.get('patient').clinic_num,
            healthcardno:this.$storage.get('patient').healthCardId,
            patientid:this.$storage.get('patient').patient_id,
          }).then(res=>{
            loading.close();
            this.reportjylist = res.Data
          })
        },
        getReportjclist(){
          getreportjclist({
            startdate:this.$route.query.startDate,
            enddate:this.$route.query.endDate,
            name:this.$storage.get('patient').clinic_patient_name,
            cardnum:this.$storage.get('patient').clinic_num,
            healthcardno:this.$storage.get('patient').healthCardId,
            patientid:this.$storage.get('patient').patient_id,
          }).then(res=>{
            this.reportjclist = res.Data
          })
        },
        tojyDetails(item){
          this.$router.push({path:'/jyreport',query:{
            id:item.报告单ID,
            name:item.项目名称,
          }})
        },
        tojcDetails(index){
          this.$router.push({path:'/jcreport',query:{
            index:index,  //申请单ID
            startdate:this.$route.query.startDate,
            enddate:this.$route.query.endDate,
          }})
        },

      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/report.vue